import {
    MyAccountOrderTotals as SourceMyAccountOrderTotals
} from 'SourceComponent/MyAccountOrderTotals/MyAccountOrderTotals.component';

import './MyAccountOrderTotals.override.style';

/** @namespace PeggysagePwa/Component/MyAccountOrderTotals/Component */
export class MyAccountOrderTotalsComponent extends SourceMyAccountOrderTotals {
    /**
     * Override: remove discounts when value equals zero
     * @return {unknown[]|null}
     */
    renderDiscounts() {
        const { total: { discounts = [] } } = this.props;

        if (!discounts.length) {
            return null;
        }

        return discounts
            .filter((discount) => Math.abs(discount.amount.value) !== 0)
            .map(this.renderDiscount.bind(this));
    }

    /**
     * Override: discount value is already negative
     * @param label
     * @param value
     * @param index
     * @returns {*}
     */
    renderDiscount({ label, amount: { value } }, index) {
        const discountLabel = label ? __('Discount (%s)', label) : __('Discount');

        return this.renderPriceLine(discountLabel, value, null, {}, `discount-${index}`);
    }

    /**
     * Override: remove subtotal, base grand total
     * @returns {JSX.Element}
     */
    renderContent() {
        const {
            total: {
                subtotal: {
                    value: subtotalPrice
                },
                shipping_handling: {
                    total_amount: {
                        value: shippingHandlingPrice
                    }
                },
                grand_total: {
                    value: grandTotalPrice
                },
                total_tax: {
                    value: totalTaxPrice
                }
            }
        } = this.props;

        const grandTotalMix = { block: 'MyAccountOrderTotals', elem: 'GrandTotal' };

        return (
            <>
                { this.renderPriceLine(__('Subtotal'), subtotalPrice) }
                { this.renderDiscounts() }
                { this.renderPriceLine(__('Shipping & Handling'), shippingHandlingPrice) }
                { /* this.renderPriceLine(
                    __('Grand Total (Excl.Tax)'),
                    grandTotalPrice - totalTaxPrice,
                    null,
                    grandTotalMix
                ) */ }
                { /* this.renderTaxes() */ }
                { this.renderPriceLine(__('Tax'), totalTaxPrice) }
                { this.renderPriceLine(__('Grand Total (Incl.Tax)'), grandTotalPrice, null, grandTotalMix) }
                { /* this.renderBaseGrandTotal() */ }
            </>
        );
    }
}

export default MyAccountOrderTotalsComponent;
